import type { FavoriteViewList } from '@/api/favorites'

interface ShoesFavoriteViewInput {
  id: string
  title: string
  familyId: number
  season: string
  countries: string[]
  supermodelCount: number
  imageId: string
  createdAt: string
}

function createShoesFavoriteView(input: ShoesFavoriteViewInput): FavoriteViewList['items'][number] {
  return {
    id: input.id,
    title: input.title,
    folderId: '0002',
    search: {
      resource: 'MODELS',
      season: input.season,
      hierarchy: { familyIds: [input.familyId] },
      filters: { sports: [4], homologation_countries: input.countries },
      order: 'PRICE_ASC',
      routeContext: { universeId: 1, departmentId: 4, subdepartmentId: 21, familyPath: 'subdepartment' },
    },
    supermodelCount: input.supermodelCount,
    previewImageUrl: `https://contents.mediadecathlon.com/p${input.imageId}/k$6093cdb9819e83974fe1d3aec63a5ada/picture.jpg?format=auto&f=1200x1200`,
    createdAt: input.createdAt,
    updatedAt: input.createdAt,
  }
}

const additionalShoesViews = [
  { id: 'favorite-view-shoes-trail', title: 'Trail running shoes', familyId: 108202, season: 'SS26', countries: ['FR', 'DE'], supermodelCount: 42, imageId: '3024477', createdAt: '2026-01-22T10:00:00.000Z' },
  { id: 'favorite-view-shoes-hiking', title: 'Mid hiking shoes', familyId: 108203, season: 'AW25', countries: ['US'], supermodelCount: 18, imageId: '3024543', createdAt: '2026-01-23T10:00:00.000Z' },
  { id: 'favorite-view-shoes-walking', title: 'Everyday walking shoes', familyId: 108204, season: 'AW26', countries: [], supermodelCount: 56, imageId: '3012600', createdAt: '2026-01-24T10:00:00.000Z' },
  { id: 'favorite-view-shoes-womens-road', title: 'Women road running shoes', familyId: 108205, season: 'AW26', countries: ['FR'], supermodelCount: 34, imageId: '3039011', createdAt: '2026-01-25T10:00:00.000Z' },
  { id: 'favorite-view-shoes-waterproof', title: 'Waterproof hiking boots', familyId: 108206, season: 'SS27', countries: ['DE'], supermodelCount: 9, imageId: '3024477', createdAt: '2026-01-26T10:00:00.000Z' },
  { id: 'favorite-view-shoes-kids', title: 'Kids running shoes', familyId: 108207, season: 'AW26', countries: ['FR', 'DE', 'ES'], supermodelCount: 21, imageId: '3024543', createdAt: '2026-01-27T10:00:00.000Z' },
  { id: 'favorite-view-shoes-sneakers', title: 'Everyday sneakers', familyId: 108208, season: 'SS27', countries: [], supermodelCount: 66, imageId: '3012600', createdAt: '2026-01-28T10:00:00.000Z' },
].map(createShoesFavoriteView)

export const mockFavoriteViews: FavoriteViewList = {
  items: [
    {
      id: 'favorite-view-running',
      title: 'Spring running models',
      folderId: null,
      search: {
        resource: 'SUPERMODELS',
        season: 'SS26',
        hierarchy: { departmentId: 4 },
        filters: { homologation_countries: ['FR'] },
        order: 'SEGMENTATION_ASC',
        routeContext: { universeId: 1, departmentId: 4, familyPath: 'subdepartments' },
      },
      supermodelCount: 12,
      previewImageUrl: 'https://contents.mediadecathlon.com/p2621178/k$3a14bf04e31b58bd74f5618ac1c56289/sq/bonnet-de-ski-de-fond-noir-xc-s-beanie-500-enfant.jpg?format=auto&f=1200x1200',
      createdAt: '2026-01-15T10:00:00.000Z',
      updatedAt: '2026-01-15T10:00:00.000Z',
    },
    {
      id: 'favorite-view-shoes',
      title: 'Road running shoes',
      folderId: '0002',
      search: {
        resource: 'MODELS',
        season: 'SS26',
        hierarchy: { familyIds: [108201] },
        filters: { sports: [4], homologation_countries: ['FR', 'DE'] },
        order: 'PRICE_ASC',
        routeContext: { universeId: 1, departmentId: 4, subdepartmentId: 21, familyPath: 'subdepartment' },
      },
      supermodelCount: 24,
      previewImageUrl: 'https://contents.mediadecathlon.com/p3024477/k$6093cdb9819e83974fe1d3aec63a5ada/picture.jpg?format=auto&f=1200x1200',
      createdAt: '2026-01-18T14:30:00.000Z',
      updatedAt: '2026-01-18T14:30:00.000Z',
    },
    {
      id: 'favorite-view-fishing',
      title: 'Pole fishing',
      folderId: '0004',
      search: {
        resource: 'MODELS',
        season: 'AW26',
        hierarchy: { subdepartmentId: 3170 },
        filters: { homologation_countries: ['FR', 'DE'] },
        order: 'PRICE_ASC',
        routeContext: { universeId: 7, departmentId: 511, subdepartmentId: 3170, familyPath: 'subdepartment' },
      },
      supermodelCount: 24,
      previewImageUrl: null,
      createdAt: '2026-01-21T10:00:00.000Z',
      updatedAt: '2026-01-21T10:00:00.000Z',
    },
    ...additionalShoesViews,
    {
      id: 'favorite-view-badminton',
      title: 'Badminton families',
      folderId: '0003',
      search: {
        resource: 'SUPERMODELS',
        season: 'AW25',
        hierarchy: { subdepartmentId: 42 },
        filters: {},
        order: 'AVAILABILITY_DESC',
        routeContext: { universeId: 1, departmentId: 4, subdepartmentId: 42, familyPath: 'subdepartment' },
      },
      supermodelCount: 8,
      previewImageUrl: null,
      createdAt: '2026-01-20T09:15:00.000Z',
      updatedAt: '2026-01-20T09:15:00.000Z',
    },
  ],
  total: 11,
}